/* eslint-disable */
import react, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Calculate_status_coms_drivers from "../../hooks/Calculata_status_coms_drivers/Calculate_status_coms_drivers";
import PdfColor_Icon from "../icons/PdfColor_Icon";
import ExcelColor_Icon from "../icons/ExcelColor_Icon";
import CardBalance from "./CardBalance";
import { Calcular_Impuestos_Hasura } from "../../hooks/Hasura-Implementation/Calcular_Impuestos_Hasura";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { calculateCommission } from "../../hooks/Google_spreadsheet_0Auth2.0/CalculateFunctions/CalculateFunctions";
export default function TableTravels({
  Travels,
  controlWidth,
  dateRange,
  ObjectDriver,
}) {
  /*   console.log("🚀 ~ file: TableTravels.js:17 ~ Travels:", Travels); */
  const [infoBalance, setInfoBlance] = useState(null);

  const columns = [
    {
      name: "ID Viaje",
      selector: (row) => row.trip_id,
      sortable: true,
      cell: (row) => <strong>{row.trip_id.substring(0, 10)}</strong>,
    },
    {
      name: "Fecha de solicitud",
      selector: (row) => row.time_request,
      sortable: true,
      cell: (row) => (
        <strong>
          {new Date(row.time_request).toISOString().substring(0, 10)}
        </strong>
      ),
    },
    {
      name: "Método de pago",
      selector: (row) => row?.payment_method,
      sortable: true,
    },
    {
      name: "Tarifa de viaje",
      selector: (row) => row?.subtotal_tarifa_dinamica?.toFixed(2) || 0,
      sortable: true,
    },
    {
      name: "Cuota de solicitud 10%",
      selector: (row) => row?.cuota_de_solicitud?.toFixed(2) || 0,
      sortable: true,
    },
    {
      name: "IVA 8%",
      selector: (row) => row?.plataforma_iva?.toFixed(2),
      sortable: true,
    },
    {
      name: " 2.1%",
      selector: (row) => row?.impuestos_isr?.toFixed(2),
      sortable: true,
    },
    {
      name: "Uso de plataforma",
      selector: (row) => row?.uso_plataforma?.toFixed(2),
      sortable: true,
    },

    {
      name: "Comisión 15%",
      selector: (row) =>
        calculateCommission(row?.subtotal_tarifa_dinamica, 0.15),
      sortable: true,
    },
    {
      name: "Total a recibir el conductor",
      selector: (row) => row?.pago_total?.toFixed(2),
      sortable: true,
      cell: (row) => <strong>{row?.pago_total?.toFixed(2)}</strong>,
    },
  ];

  const tableCustomStyles = {
    table: {
      style: {
        zIndex: 0,
        height: "50vh",
        width: controlWidth <= 1812 ? "50vh" : "150vh",
      },
    },
  };
  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  useEffect(() => {
    setInfoBlance(Calcular_Impuestos_Hasura(Travels));
  }, []);

  return (
    <div
      style={{
        width: "100%",
        minWidth: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "row",
        gap: "15px",
      }}
    >
      <div
        style={{
          borderRadius: "10px",
          backgroundColor: "white",
          padding: "10px",
        }}
      >
        <DataTable
          title="Viajes finalizados"
          columns={columns}
          data={Travels}
          fixedHeader
          pagination
          /*           highlightOnHover */
          paginationComponentOptions={paginationComponentOptions}
          customStyles={tableCustomStyles}
        />
      </div>
    </div>
  );
}
